import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { api } from '@/api/client';
import { useAuthStore } from '@/state/authStore';

type LandingPath = '/sessions' | '/clients';

export function DefaultLanding() {
  const user = useAuthStore((s) => s.currentUser);
  const [path, setPath] = useState<LandingPath | null>(null);

  useEffect(() => {
    if (!user) return;

    if (user.is_admin) {
      setPath('/sessions');
      return;
    }

    let cancelled = false;
    api.get('/sessions')
      .then((r) => {
        if (cancelled) return;
        const sessions = Array.isArray(r.data)
          ? (r.data as Array<{ requires_my_action?: boolean }>)
          : [];
        setPath(sessions.some((s) => s.requires_my_action === true) ? '/sessions' : '/clients');
      })
      .catch(() => {
        if (!cancelled) setPath('/clients');
      });

    return () => {
      cancelled = true;
    };
  }, [user]);

  if (path) return <Navigate to={path} replace />;

  return (
    <div className="p-8 text-center text-sm text-gray-500">
      初期画面を確認しています...
    </div>
  );
}
